var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTickSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.667 8C.667 3.965 3.965.667 8 .667S15.333 3.965 15.333 8 12.035 15.333 8 15.333.667 12.035.667 8ZM8 2C4.702 2 2 4.7 2 8c0 3.298 2.702 6 6 6 3.299 0 6-2.702 6-6 0-3.3-2.7-6-6-6Zm3.305 3.642c.26.26.26.683 0 .943l-3.78 3.773a.667.667 0 0 1-.943 0L4.695 8.47a.667.667 0 1 1 .943-.943l1.416 1.416 3.308-3.303a.667.667 0 0 1 .943.001Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickSuccess);
export default __webpack_public_path__ + "static/media/icon_tick-success.6b0315a262a82966b060f5d1b35f3964.svg";
export { ForwardRef as ReactComponent };